<template>
  <div id="partners-wrapper">
    <app-header></app-header>

    <div class="container">
      <div class="message">TEDxOsakaUは、様々な企業・団体から協賛を頂いて活動しています。</div>
      <div class="row">
        <div class="partner-cell col-lg-3 col-md-4 col-6"
             v-for="(partner, index) in partners.primary"
             v-bind:key="index">
          <a v-bind:href="partner.link" target="_blank">
            <img class="partner-image" v-bind:src="partner.img" v-bind:alt="partner.name"/>
          </a>
        </div>
      </div>
      <div class="row">
        <div class="partner-cell col-lg-2 col-md-3 col-4"
             v-for="(partner, index) in partners.secondary"
             v-bind:key="index">
          <a :href="partner.link" target="_blank">
            <img class="partner-image" v-bind:src="partner.img" v-bind:alt="partner.name"/>
          </a>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PartnersData from '@/assets/partners.json';


export default {
  name: 'Partners',
  components: {
    'app-header': Header,
    'app-footer': Footer,
  },
  data() {
    return {
      partners: PartnersData,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/global";

#partners-wrapper {
  margin-top: 96px;
  padding: 0;
}

.message {
  margin: 8px 0 12px 8px;
  font-size: 18px;
}

.partner-cell {
  padding: 6px;

  @include media-breakpoint-down(md) {
    padding: 4px;
  }
}

.partner-image {
  padding: 4px;
  border: solid 1px rgba($brand-lighter, .3);
  width: 100%;
}

.partner-image:hover {
  border: solid 1px rgba($brand-lighter, .7);
}
</style>



// WEBPACK FOOTER //
// src/components/Partners.vue